/** Owner policy can replace this default list in the later Line-policy phase. */
export const DEFAULT_CREATE_PHRASES = [
  'new plan from this',
  'create a fresh plan using',
  'branch a new plan',
  'start a new plan referencing',
  'seed a new plan from',
  'start over with this as reference',
] as const

/** Returns the matched phrase so callers can record the deterministic winner. */
export const findLineCreatePhrase = (message: string, createPhrases: readonly string[] = DEFAULT_CREATE_PHRASES): string | null => {
  const normalized = message.toLocaleLowerCase()
  return createPhrases.find((phrase) => normalized.includes(phrase.toLocaleLowerCase())) ?? null
}
